import { SET_CUSTOMER_VEHICLES } from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.customerVehicles, action) {
  switch (action.type) {
    case SET_CUSTOMER_VEHICLES:
      return action.payload;
    case RESET_APP_STATE:
      return initialState.customerVehicles;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/customerVehicles/reducer.js